import { ReviewSubjectType } from "@/api/cle-api";

const reviewSubjectTypeLabels: Record<ReviewSubjectType, string> = {
  [ReviewSubjectType.COURSE_CERTIFICATE]: "Kursusbevis",
  [ReviewSubjectType.INSURANCE_POLICY]: "Forsikringspolice",
  [ReviewSubjectType.TEACHING]: "Undervisning",
  [ReviewSubjectType.REDUCTION]: "Reduktion",
  [ReviewSubjectType.LEGAL_AID]: "Advokatvagt/retshjælp",
  [ReviewSubjectType.AUTHORSHIP]: "Forfatterskab",
  [ReviewSubjectType.DISPENSATION]: "Dispensation",
};

export const reviewSubjectTypeOptions = Object.values(ReviewSubjectType).map(
  (value) => ({
    value,
    label: reviewSubjectTypeLabels[value],
  }),
);

export const formatReviewSubjectType = (subjectType: string): string =>
  reviewSubjectTypeLabels[subjectType as ReviewSubjectType] ?? subjectType;
